<template>
  <div>
    <span
      v-if="
        (typeof ballotResponseID === 'string' || typeof ballotResponseID === 'number') &&
          documentID > 0
      "
    >
      <button
        class="button is-info is-light is-small is-outline is-rounded"
        @click.prevent="downloadPdf(ballotResponseID)"
      >
        Pdf
      </button>
    </span>
    <span v-else>
      &nbsp;
    </span>
  </div>
</template>

<script>
export default {
  props: {
    ballotResponseID: [Number, String],
    documentID: [Number, String],
    downloadPdf: Function
  }
}
</script>
